export default "__VITE_ASSET__56b3a36f__"